import { ProductPageLayout } from '~/components/ProductPageLayout/ProductPageLayout'
import { PromoLeadPopup } from '~/components/PromoLeadPopup/PromoLeadPopup'
import { ProductPage } from '~/components/ProductPage/WorkTableProductPage'
import { WorkTableConfiguration } from '~/components/ProductPage/productTypes/workTable'
import { useFurnitureBySku } from '~/utils/furnitureBySku'
import { FurnitureProvider } from '~/context/furnitureContext'

export default function WorkTableConfiguratorPage() {
  const furniture = useFurnitureBySku('work-table')

  return (
    <FurnitureProvider value={furniture}>
      <ProductPageLayout fullWidth showBreadcrumbs={false} showDescription={false}>
        <ProductPage
          components={WorkTableConfiguration}
          name="homepage.configurator.work-table.title"
        />
      </ProductPageLayout>
      <PromoLeadPopup />
    </FurnitureProvider>
  )
}
